<div class="sub-navbar">
    <q-navigation
        [homePage]="homePage"
        [navigationList]="navigationList"
        [currentPage]="selectedNavPage"
    ></q-navigation>
</div>
